import { Component, OnInit, inject } from '@angular/core';
import { LoaderService } from './modules/loaders';
import { MessagesBusService } from './modules/messages';
import { LanguageService } from './i18n';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { WindowService } from './shared/services';
import { CleanupService } from './core/services/cleanup.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    // needs to be initiated
    readonly router = inject(Router);
    readonly windowService = inject(WindowService);
    readonly loaderService = inject(LoaderService);
    readonly messagesService = inject(MessagesBusService);
    readonly languageService = inject(LanguageService);
    readonly cleanupService = inject(CleanupService);

    ngOnInit() {
        this.router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                filter((event) => event.url !== '/logout' && !event.url.startsWith('/distribution/planning/steps')),
                tap(() => {
                    this.windowService.scrollToTop();
                }),
            )
            .subscribe();
    }
}
